module.exports = __webpack_public_path__ + "img/1_1.53b033b7.png";